import { apiConfig } from "./apiConfig";
import { isEliteBanner } from "../constants/eliteSite";
import { GAC_MARCA, tagGacBannerName } from "../constants/gacSite";

const filterGacBanners = (banners = []) =>
  banners.filter((banner) => !isEliteBanner(banner));

const saveBanner = async (payload) => {
  return await apiConfig.post("/banners/create", {
    ...payload,
    name: tagGacBannerName(payload.name),
    marca: GAC_MARCA,
  });
};

const getBannerGac = async () => {
  const response = await apiConfig.get("/banners");
  const data = Array.isArray(response.data) ? response.data : [];

  return {
    ...response,
    data: filterGacBanners(data),
  };
};

const deleteBanner = async (id) => {
  return await apiConfig.delete(`banners/delete/${id}`);
};

const updateBanner = async (id, payload) => {
  return await apiConfig.patch(`banners/update/${id}`, {
    ...payload,
    name: tagGacBannerName(payload.name),
    marca: GAC_MARCA,
  });
};

export { saveBanner, getBannerGac, deleteBanner, updateBanner, filterGacBanners };
